<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 80 80"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <rect x="40.8" y="48.4" width="17" height="3.4" />
      <rect x="47.6" y="55.2" width="3.4" height="3.4" />
      <rect x="54.4" y="55.2" width="3.4" height="3.4" />
      <rect x="47.5" y="62" width="3.4" height="3.4" />
      <rect x="54.3" y="62" width="3.4" height="3.4" />
      <rect x="40.8" y="55.2" width="3.4" height="3.4" />
      <rect x="40.8" y="62" width="3.4" height="3.4" />
      <path
        d="M40,39.6c3.2,0,5.9-2.6,5.9-5.8c0-3.2-2.6-5.8-5.9-5.8s-5.9,2.6-5.9,5.8C34.2,37,36.8,39.6,40,39.6z M40,31.3 c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5C37.5,32.4,38.7,31.3,40,31.3z"
      />
      <rect x="30.6" y="11.3" width="1.7" height="6.7" />
      <rect x="30.6" y="8" width="1.7" height="1.5" />
      <rect x="47.6" y="8" width="1.7" height="1.5" />
      <rect x="39.2" y="16.4" width="1.7" height="1.6" />
      <rect x="39.2" y="4.6" width="1.7" height="10.1" />
      <rect x="47.6" y="11.3" width="1.7" height="6.7" />
      <path
        d="M23.2,61.5L23.2,61.5l-1.3,0.5l0.1,0.1c1.5,2.1,3.8,3.2,6.3,3.2c1.2,0,2.5-0.3,3.7-0.9c2-0.9,3.6-2.6,4.3-4.7
			s0.7-4.4-0.3-6.4c-0.1-0.2-0.2-0.4-0.3-0.6l-0.1-0.1L32,54.5c-0.4-0.8-1-1.6-1.6-2.2l2.3-1.1c0.4,0.3,0.8,0.7,1.1,1.1l0.1,0.1
			l1.2-0.6l-0.1-0.1c-2.3-3.1-6.3-4-10-2.3c-4.2,2-6,6.9-4,11.1c0.1,0.1,0.1,0.3,0.2,0.4l0.1,0.1l3.7-1.7c0.4,0.8,1,1.6,1.6,2.3
			l-2.2,1C23.9,62.3,23.5,61.9,23.2,61.5z M30.5,63.6c-0.1,0-0.1-0.1-0.2-0.1c-1-0.4-1.9-1-2.7-1.8l2.2-1l1.3,2.7
			C30.9,63.5,30.7,63.6,30.5,63.6z M32.4,62.5c0,0.1,0,0.2-0.1,0.2c-0.2,0.1-0.4,0.3-0.7,0.4l-1.3-2.7l2.3-1.1
			C32.8,60.4,32.7,61.5,32.4,62.5z M33.1,62.2c0.2-0.8,0.3-1.8,0.2-3.1l2.1-1C35.1,59.7,34.3,61.1,33.1,62.2z M35,54.5
			c0.3,0.9,0.5,1.9,0.4,2.9l-2.2,1c-0.1-0.9-0.4-1.9-0.7-2.7L35,54.5z M32.7,58.7l-2.6,1.2l-1.2-2.5l3-1.4
			C32.3,56.8,32.5,57.7,32.7,58.7z M31.4,54.7l-3,1.4l-1.1-2.4l2.5-1.2C30.4,53.2,30.9,53.9,31.4,54.7z M32,50.8l-2.1,1
			c-0.9-0.9-1.9-1.5-2.6-1.8C29,49.6,30.6,49.9,32,50.8z M26.3,50.2c0.1,0,0.2,0.1,0.3,0.1c0.9,0.4,1.8,1,2.6,1.7L27,53.1l-1.2-2.7
			C25.9,50.4,26.1,50.3,26.3,50.2z M24.6,51.3c0-0.1,0.1-0.2,0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l1.2,2.7l-2.2,1
			C24.2,53.3,24.3,52.3,24.6,51.3z M23.9,51.6c-0.2,1-0.3,2-0.3,3.1l-2,0.9C21.9,54.1,22.7,52.7,23.9,51.6z M21.9,59.2
			c-0.3-0.9-0.4-1.8-0.4-2.8l2.2-1c0.1,0.9,0.3,1.8,0.7,2.7L21.9,59.2z M24.2,55.1l2.4-1.1l1.1,2.4l-2.9,1.4
			C24.6,56.9,24.3,56,24.2,55.1z M25.4,59l2.9-1.4l1.2,2.5l-2.4,1.1C26.4,60.6,25.9,59.8,25.4,59z M27,62c0.8,0.8,1.6,1.4,2.5,1.9
			c-1.7,0.3-3.3,0-4.7-0.9L27,62z"
      />
      <path d="M67.9,47.3c0-0.4-0.5-0.6-0.8-0.3l-2.6,2.6l0,22.5h-49v-5h-3.4v8.4h55.7L67.9,47.3z" />
      <path
        d="M12.1,63.1c0,0.4,0.5,0.6,0.8,0.3l2.6-2.6l0-24.3h6.8v6.8h35.5v-6.8h6.8v6.8h3.4V33.2H57.7H51V19.7H29.1l0,13.5h-6.8H12.1
			L12.1,63.1z M38.3,23.1h3.5c0.5,3.1,2.8,5.5,5.9,6v10.8H32.4l0-10.8C35.5,28.5,37.8,26.1,38.3,23.1z M54.4,36.6V40H51v-3.4H54.4z
			M47.6,25.6c-1.2-0.4-2.1-1.3-2.4-2.5h2.4V25.6z M34.8,23.1c-0.3,1.1-1.2,2.1-2.3,2.5l0-2.5H34.8z M29.1,36.6l0,3.4h-3.4v-3.4H29.1
			z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-smart-cash",
  components: {},
})
export class IconLogic extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
  @Prop({ default: "#ffd102" }) public color2!: string;

  constructor() {
    super();
  }
}
export default IconLogic;
</script>
